import { useEffect, useState, useRef } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import { TablePaginate } from "../../../layout/Datagrid/TablePaginate";
import { useNavigate } from "react-router-dom";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import getColumnsSolicitudPE from "../../../layout/Columns/ColumnsSolicitudPE";
import { Download } from "@mui/icons-material";
import * as XLSX from 'xlsx';
import { guardarDatosMontosPE, obtenerDatosPE } from "../../../services/PpafeServicesPE";



const SolicitudReportePE = () => {
    const [fecha, setFecha] = useState<dayjs.Dayjs | null>(dayjs());
    const [titulo, setTitulo] = useState<string>("Participaciones Estatales ");
    const [currentPage, setCurrentPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(100);
    const [dataLoading, setDataLoading] = useState(false);
    const navigate = useNavigate();
    const TITULO = "Solicitud de Alta Participaciones Estatales Montos";
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [responseData, setResponseData] = useState<any[]>([]);
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (responseData.length > 0) {
            scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [responseData]);


    // Función para obtener los datos
    const handleObtenerDatos = () => {
        if (!fecha) {
            setError("Por favor selecciona una fecha válida.");
            return;
        }

        const anio = fecha.year();
        const mes = fecha.month() + 1;
        const tipo = "participaciones"; // Aquí puedes cambiarlo dinámicamente
        const origen = "estatales"; // También puedes pasarlo según la pantalla

        obtenerDatosPE(anio, mes, tipo, origen, setLoading, setResponseData, setError);
    };
    const handleGuardar = () => {
        const tipo = "participaciones"; // Aquí puedes cambiarlo dinámicamente
        const origen = "estatales"; // También puedes pasarlo según la pantalla
        guardarDatosMontosPE(titulo, fecha, tipo, origen, responseData, setResponseData, setLoading, setError, navigate);
    };


    const handleVerClick = (id: string, link: string) => {
        navigate("/" + link + "/alta/" + id);
    };
    const columns = getColumnsSolicitudPE({ handleVerClick, urlOrigen: '/usuarios/listado', rows: Array.isArray(responseData) ? responseData : [] });

    const exportToExcel = () => {
        if (!responseData || responseData.length === 0) {
            console.warn("No hay datos para exportar.");
            return;
        }

        /* ------------------------------------------------------------------ */
        /* 1. CALCULAR total_monto ANTES DE GENERAR COLUMNAS Y FILAS           */
        /* ------------------------------------------------------------------ */

        // Campos que intervienen en el total (solo ICV e ISN en este reporte)
        const camposNumericos = ["ICV", "ISN"];

        // Clonamos cada fila y añadimos total_monto
        const datosConTotales = responseData.map((fila) => {
            const total = camposNumericos.reduce((acc, campo) => {
                let valor: string | number | undefined = fila[campo];

                if (typeof valor === "string") valor = parseFloat(valor.replace(/,/g, ""));
                if (typeof valor !== "number" || isNaN(valor)) valor = 0;

                return acc + valor;
            }, 0);

            return { ...fila, total_monto: total };
        });

        /* ------------------------------------------------------------------ */
        /* 2. RESTO DE LA FUNCIÓN (usa datosConTotales y quita comas)          */
        /* ------------------------------------------------------------------ */

        // Devuelve string con 2 decimales SIN comas
        const formatNumber = (num: string | number | null | undefined) => {
            if (num === undefined || num === null || num === "") return "0.00";
            if (typeof num === "string") num = parseFloat(num.replace(/,/g, ""));
            return !isNaN(num) ? (num as number).toFixed(2) : "0.00";
        };

        const tituloReporte = [[titulo]];

        const allColumns = [
            { field: "Municipio:", header: "Municipios" },
            { field: "ICV", header: "Impuesto Sobre Nóminas" },
            { field: "ISN", header: "Derechos de Control Vehicular" },
            { field: "total_monto", header: "Totales" },
        ];

        // Filtramos las columnas que realmente tienen datos ≠ 0
        const validColumns = allColumns.filter(({ field }) => {
            if (field === "Municipio:") return true;

            return datosConTotales.some((item) => {
                const value = item[field];
                if (value === undefined || value === null || value === "") return false;
                const numericValue =
                    typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
                return !isNaN(numericValue) && numericValue !== 0;
            });
        });

        // Construimos las filas en el orden de validColumns
        const formattedData = datosConTotales.map((item) =>
            validColumns.map(({ field }) => {
                if (field === "Municipio:") return item["Municipio"] || "";
                return formatNumber(item[field]);
            })
        );

        const headers = [validColumns.map((col) => col.header)];

        const ws = XLSX.utils.aoa_to_sheet([
            ...tituloReporte,
            ...headers,
            ...formattedData,
        ]);

        // Unir celdas del título
        ws["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: headers[0].length - 1 } },
        ];

        // Estilo del título y ancho de columnas
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" },
        };
        ws["!cols"] = Array(headers[0].length).fill({ wch: 25 });

        // Crear libro y hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Datos");

        // Generar y descargar
        const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([buffer], {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Reporte_Datos.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };


    useEffect(() => {
        if (fecha) {
            const mes = fecha.format("MMMM"); // Ej: "abril"
            const anio = fecha.format("YYYY"); // Ej: "2025"
            const nuevoTitulo = `Participaciones Estatales ${capitalizeFirstLetter(mes)} ${anio}`;
            setTitulo(nuevoTitulo);
        }
    }, [fecha]);

    const capitalizeFirstLetter = (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };


    return (

        <Grid container sx={{}}>
            <Grid item mb={2} width={"100%"}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                        { texto: "Montos", link: "/admin/participaciones/estatales/montos" },
                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid item width={"100%"} >

                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        fontWeight: "bold",
                        display: "flex",
                        justifyContent: "left",
                        marginBottom: "0.5rem"
                    }}

                >
                    {TITULO}
                </Typography>

            </Grid>

            <Grid item mb={2} width={"100%"} sx={{ marginBottom: "1rem" }}>
                <p>Nota: Por favor, asegúrese de llenar todos los campos obligatorios antes de guardar la información.</p>
                <TextField
                    label="Título"
                    fullWidth
                    value={titulo}
                    onChange={(e) => setTitulo(e.target.value)}
                    sx={{ marginTop: "1rem", }}
                />
            </Grid>

            <Grid container item xs={12} spacing={2} sx={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>

                <Grid item xs={12} md={5.5}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha"
                            value={fecha}
                            onChange={(newValue) => setFecha(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth sx={{ textTransform: "capitalize", height: "100%", width: "100%" }} />
                            )}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} md={5.5} >
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ textTransform: "capitalize", height: "3.7rem", width: "100%" }}
                        onClick={handleObtenerDatos}
                        disabled={loading}
                    >
                        {loading ? "Obteniendo..." : "Obtener Reporte de Participaciones Estatales"}
                    </Button>
                </Grid>

            </Grid>
            <TablePaginate
                rowsInfo={responseData}
                columns={columns}
                Mostrar={false}
                loading={dataLoading}
            />

            <Grid
                container
                spacing={2}
                sx={{ mt: 2 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
            >
                <Grid item xs={12} md="auto">
                    <Button
                        startIcon={<Download />}
                        onClick={exportToExcel}
                        variant="contained"
                        color="primary"
                        fullWidth={true}
                        sx={{ textTransform: "capitalize" }}
                    >
                        Exportar a Excel
                    </Button>
                </Grid>

                <Grid item xs={12} md="auto">
                    <Button
                        variant="contained"
                        onClick={() => navigate("/admin/participaciones/estatales/montos")}
                        style={{ backgroundColor: "#C1A25C" }}
                        fullWidth={true}
                        sx={{ textTransform: "capitalize" }}
                    >
                        Cancelar
                    </Button>
                </Grid>

                <Grid item xs={12} md="auto">
                    <Button
                        variant="contained"
                        onClick={handleGuardar}
                        color="primary"
                        fullWidth={true}
                        sx={{ textTransform: "capitalize" }}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
            <div ref={scrollRef} />
        </Grid >
    );
};

export default SolicitudReportePE;
